import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UnpublishedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"unpublished"}/>
}
